import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { Select } from 'antd'
import { useSelector } from 'react-redux'
import { CreatePersonalTrainingSubscriptionTeacherTimeTableService, UpdatePersonalTrainingSubscriptionTeacherService, UpdatePersonalTrainingSubscriptionTeacherTimeTableService,RegenerateGoogleMeetBatchBookingService } from '../../services/class_booking/classBookingServices'
import SettingsMenu from '../staticscreens/SettingsMenu'
import BatchBookingMenu from '../batch_booking/BatchBookingMenu'
import { GetClientService, GetOfflineClientService } from '../../services/ClientServices'
import { GetTeacherSearchService } from '../../services/class_booking/TeacherServices'

function BatchSubscriptionTimeTableCE() {

  const roles = useSelector(state=>state.Auth.roles)
  const user = useSelector(state=>state.Auth)
  const isTeacher = user?.logged_user_type === 'Teacher'
  const studentLabel = (s) => isTeacher ? s?.name : `${s?.name} - [${s?.mobile}]`
  const {state} = useLocation()
  const {pathname} = useLocation()
  const path = pathname?.split('/')?.[pathname?.split('/')?.length - 1]


  console.log("state",state,path)
  
  const [data, setdata] = useState({date: '', meet_link: '', remarks: '',class_status:'',heading:'',topics_covering:''});
  const [error, seterror] = useState({date: '', meet_link: '', remarks: '',class_status:'',heading:'',topics_covering:''});

  const [student,setstudent] = useState([])
  const [classroom,setclassroom] = useState([])
  const [teacherArr,setteacherArr] = useState([])

  const navigate = useNavigate();

  const  classStatusOptions = [
    {label:'Upcoming',value:'upcoming'},
    {label:'Completed',value:'completed'},
    {label:'Cancelled',value:'cancelled'},
  ]

  console.log("state",state)

  useEffect(() => {
    if (state?.data?._id !== null && state?.data?._id !== undefined) {
      let d = state?.main_data 
      let d1 = state?.data 
      let passData = {...d1,date: d1?.date ? d1?.date?.split('T')?.[0] : '',meet_link:d1?.meet_link,remarks:d1?.remarks,heading:d1?.heading,topics_covering:d1?.topics_covering}
      // Prefer the teacher already saved on this day's entry (day-wise assignment) over the batch's default teacher
      if(d1?.teacher){
        passData['teacher'] = {label:d1?.teacher?.name,value:d1?.teacher?._id}
      }else if(d?.teacher){
        passData['teacher'] = {label:d?.teacher?.name,value:d?.teacher?._id}
      }
      if(d?.students){
        passData['students'] = d?.students?.map((s)=>({label:studentLabel(s),value:s?._id}))
      }

      if(d?.batch){
        passData['batch'] =  {label:`${formatTo12Hour(d?.batch?.start_time)} - ${formatTo12Hour(d?.batch?.end_time)}`,value:d?.batch?._id}
      }
      if(d?.class_status){
        passData['class_status'] = classStatusOptions?.find((c)=>c?.value === d?.class_status)
      }

      if(d?.class_room){
        passData['classroom'] = d?.class_room?._id ? {label:`${d?.class_room?.label} [${d?.class_room?.name}]`,value:d?.class_room?._id} : ''
      }else{
        delete passData['classroom']
      }

      setdata(passData)

    }else{
      let d = state?.main_data
      let passData = {...d}
      if(d?.teacher){
        passData['teacher'] = {label:d?.teacher?.name,value:d?.teacher?._id}
      }

       if(d?.students){
        passData['students'] = d?.students?.map((s)=>({label:studentLabel(s),value:s?._id}))
      }

      if(d?.batch){
        passData['batch'] =  {label:`${formatTo12Hour(d?.batch?.start_time)} - ${formatTo12Hour(d?.batch?.end_time)}`,value:d?.batch?._id}
      }

      if(d?.class_room){
        passData['classroom'] = d?.class_room?._id ? {label:`${d?.class_room?.label} [${d?.class_room?.name}]`,value:d?.class_room?._id} : ''
      }else{
        delete passData['classroom']
      }

      passData['class_status'] = classStatusOptions?.find((c)=>c?.value === 'upcoming')

      delete passData['remarks']

      setdata(passData)
    }
  }, [state])



  async function handlechange(e) {
    let {name,value} = e.target
    setdata({ ...data, [name]: value })
    seterror({ ...error, [name]: '' })
  }



  async function submitform() {
    if (state?.main_data?.mode === 'online' && !data.meet_link) {
      seterror({ ...error, meet_link: 'This field is required *' })
    }else {
        let sendData = { ...data }
        sendData['batch'] = data?.batch?.value
        sendData['class'] = data?.class?.value
        sendData['students'] = data?.students?.map((s)=>s?.value)
        sendData['class_status'] = data?.class_status?.value
        sendData['personal_training_subscription_teacher_batch'] = state?.main_data?._id
        if(data?.teacher?.value){
          sendData['teacher'] = data?.teacher?.value
        }else{
          delete sendData['teacher']
        }
   
        delete sendData['createdAt']
        delete sendData['updatedAt']
        delete sendData['_id']
        delete sendData['__v']

        if(path !== 'edit'){
        const response = await CreatePersonalTrainingSubscriptionTeacherTimeTableService(sendData)
        if (response.status === 201) {
          resetForm()
          let d = state?.main_data
          let passData = {...d}
          if(d?.teacher){
            passData['teacher'] = {label:d?.teacher?.name,value:d?.teacher?._id}
          }

          if(d?.students){
            passData['students'] = d?.students?.map((s)=>({label:s?.name,value:s?._id}))
          }

          if(d?.batch){
            passData['batch'] =  {label:`${formatTo12Hour(d?.batch?.start_time)} - ${formatTo12Hour(d?.batch?.end_time)}`,value:d?.batch?._id}
          }

          passData['class_status'] = classStatusOptions?.find((c)=>c?.value === 'upcoming')

          delete passData['remarks']

          setdata(passData)
          toast.success('Batch Subscription Time Table Info Created Successfully')
        }
        }else{
           const response = await UpdatePersonalTrainingSubscriptionTeacherTimeTableService(sendData,state?.data?._id)
          if (response.status === 200) {
            resetForm()
            let d = state?.main_data
            let passData = {...d}
            if(d?.teacher){
              passData['teacher'] = {label:d?.teacher?.name,value:d?.teacher?._id}
            }

            if(d?.students){
              passData['students'] = d?.students?.map((s)=>({label:s?.name,value:s?._id}))
            }

            if(d?.batch){
              passData['batch'] =  {label:`${formatTo12Hour(d?.batch?.start_time)} - ${formatTo12Hour(d?.batch?.end_time)}`,value:d?.batch?._id}
            }

            passData['class_status'] = classStatusOptions?.find((c)=>c?.value === 'upcoming')

            delete passData['remarks']

            setdata(passData)
            navigate(-1)
            toast.success('Batch Subscription Time Table Info Updated Successfully')
          }
      }
  }
  }



  async function handleSelect(e,e1){
    if(e1 === 'student'){
      let arr = []
      e?.forEach((ele)=>{
        arr?.push(student?.find((r)=>r?.value === ele))
      })
      setdata({...data,students:arr})
      seterror({...error,roles:''})
    }

    if(e1 === 'class_status'){
      setdata({...data,class_status:classStatusOptions?.find((c)=>c?.value === e)})
      seterror({...error,class_status:''})
    }

    if(e1 === 'teacher'){
      setdata({...data,teacher:teacherArr?.find((r)=>r?.value === e)})
      seterror({...error,teacher:''})
    }
  }

   const formatTo12Hour = (time) => {
      if (!time) return "";

      const [hours, minutes] = time.split(":");
      let h = parseInt(hours, 10);
      const ampm = h >= 12 ? "PM" : "AM";

      h = h % 12 || 12; // convert 0 -> 12
      return `${h}:${minutes} ${ampm}`;
  };

  function resetForm(){
    setdata({date: '', meet_link: '', remarks: '',class_status:'',heading:'',topics_covering:''})
    seterror({date: '', meet_link: '', remarks: '',class_status:'',heading:'',topics_covering:''})
  }

    async function handleSearch(value,e1){
      if(e1 === 'teacher'){
        const response = await GetTeacherSearchService(value,1,'Batch',state?.main_data?.mode || data?.mode)
        let arr = []
        response?.data?.datas?.forEach((d)=>{
          arr.push({label:d?.name,value:d?._id})
        })
        setteacherArr(arr)
      }

       if(e1 === 'student'){
        console.log('data?.mode?.value',data?.mode)
        if(data?.mode?.value === 'online' || data?.mode === 'online'){
        const response = await GetClientService(1, '', '', '','All Data','',value)
        let arr = []
        response?.data?.datas?.forEach((d)=>{
          arr.push({label:studentLabel(d),value:d?._id})
        })
        setstudent(arr)
        } else {
          const response = await GetOfflineClientService(1, '', '', '','All Data','',value)
          let arr = []
          response?.data?.datas?.forEach((d)=>{
            arr.push({label:studentLabel(d),value:d?._id})
          })
          setstudent(arr)
        }
      }
   }

   async function generateMeetLink() {
    const response = await RegenerateGoogleMeetBatchBookingService(data?._id)
    if (response.status === 200) {
      setdata({ ...data, meet_link: response?.data?.data?.meet_link })
      toast.success('Meet Link Regenerated Successfully')
    }
    
   }
 
  console.log("state",state)
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

   
     
      <div>
      {pathname === '/batches_booking/list/time_table/edit' ? <BatchBookingMenu /> : <SettingsMenu />}
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full relative lg:w-[300px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(path === 'edit') ? 'Edit' : 'Add'} Teacher Batch Time Table</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Teacher Batch Time Table details</b> assign to you!.</h6>


          <div className='relative'>
          <TextInput
            mandatory={true}
            label={'Date'}
            variant="standard"
            name="date"
            type="date"
            error={error.date}
            value={data.date}
            readOnly={!roles?.includes('admin') && path === 'edit'}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />
            </div> 


          {state?.main_data?.mode === 'online' &&
          <div className='relative'>
          {(roles?.includes('admin') || (!state?.meet_link && !data?.meet_link)) && <h6 onClick={()=>generateMeetLink()} className='text-[14px] bg-green-400 text-black rounded p-1  font-[600] text-[9px] cursor-pointer absolute right-0 -top-[4px]'>Regenerate Meet Link</h6>}

          {/* {state?.data?.meet_link && <h6 onClick={() => {
            const separator = state?.data?.meet_link?.includes("?") ? "&" : "?";
            window?.open(`myacademy://join?room=${state?.data?.meet_link}&role=teacher`)}} className='text-[14px] text-green-600 font-[600] text-[9px] cursor-pointer absolute right-0 top-1 underline underline'>Open Meet</h6>} */}

            {data?.meet_link && (
            <h6
              onClick={() => {
                if (data.meet_link.includes("meet")) {
                  window.open(data.meet_link, "_blank");
                } else {
                  const separator = data.meet_link.includes("?") ? "&" : "?";
                  window.open(
                    `myacademy://join?room=${data?.meet_link}&role=teacher`
                  );
                }
              }}
              className="text-[14px] text-green-600 font-[800] text-[9px] cursor-pointer absolute left-[60px] top-[2px] underline"
            >
              Open Meet
            </h6>
          )}
          <TextInput
            mandatory={true}
            label={'Meet Link'}
            variant="standard"
            name="meet_link"
            type="text"
            readOnly={!roles?.includes('admin') && path === 'edit'}
            error={error.meet_link}
            value={data.meet_link}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />
            </div>} 


            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Teacher Info </h6>
                <Select
                  value={data.teacher}
                  filterOption={false}
                  showSearch
                  bordered={false}
                  placeholder=""
                  disabled={!roles?.includes('admin')}
                  onSearch={(e)=>handleSearch(e,'teacher')}
                  onChange={(e)=>handleSelect(e,'teacher')}
                  options={teacherArr}
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Batch </h6>
                <Select
                  value={data.batch} 
                  filterOption={false}
                  bordered={false}
                 disabled={!roles?.includes('admin') && path === 'edit'}
                  placeholder="" 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             {data.mode === 'offline' &&
            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class Room </h6>
                <Select
                  value={data.classroom} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  options={classroom}
                  onChange={(e)=>handleSelect(e,'classroom')} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div>} 



            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Students </h6>
                <Select
                  value={data.students} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  mode="multiple"
                  onSearch={(e)=>handleSearch(e,'student')}
                  disabled={!roles?.includes('admin') && path === 'edit'}
                  onChange={(e)=>handleSelect(e,'student')} 
                  options={student} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 
  
          <ErrorComponent error={error?.students} /> 

           <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class Status </h6>
                <Select
                  value={data.class_status} 
                  filterOption={false}
                  options={classStatusOptions}
                  bordered={false}
                  onChange={(e)=>handleSelect(e,'class_status')}
                  placeholder="" 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

            <TextAreaInput1 
          label={'Heading'}
            variant="standard"
            name="heading"
            type="text"
            error={error.heading}
            value={data.heading}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />
        

 <TextAreaInput1 
          label={'Topics Covering'}
            variant="standard"
            name="topics_covering"
            type="text"
            error={error.topics_covering}
            value={data.topics_covering}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />
        

          <TextAreaInput1 
          label={'Remarks'}
            variant="standard"
            name="remarks"
            type="text"
            error={error.remarks}
            value={data.remarks}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

         
        <div className='mt-4 flex'>
       
          <ButtonFilledAutoWidth btnName={path === 'edit' ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>


        </div>
        
       

      
      </div>

      
      </div> 

    </div>
  )
}

export default BatchSubscriptionTimeTableCE